
import { GetTokensResponse, Token, TokensQueryParams } from '../types/tokens';
import { getAccessToken } from 'utils/auth';
import { $client } from './client';

export class TokensService {
  async getTokens({ page = 1, search, limit, networkId }: TokensQueryParams) {
    try {
      const params: TokensQueryParams & { 'filter.network_id'?: string } = {};

      if (page) params.page = page;
      if (search) params.search = search;
      if (limit) params.limit = limit;
      if (networkId) params['filter.network_id'] = networkId;

      const endpoint = '/api/tokens/admin';
      const response = await $client.get<GetTokensResponse>(endpoint, { 
				params,
				headers: { authorization: getAccessToken() }
			});

      return response.data;
    } catch (error) {
      console.error(error);

      throw new Error(
        'Something went wrong, try to reload the page, or contact support.'
      );
    }
  }

	async putToken({id, isBlocked}: Partial<Token>): Promise<void> {
		const endpoint = `/api/tokens/admin/${id}`;
    try {
      const response = await $client.patch(endpoint, {isBlocked}, {
        headers: { authorization: getAccessToken() },
      });

      if (response.status === 200) {
        console.log(`Token ${id} updated successfully`);
      }
    } catch (error) {
      console.error(`Error updating token ${id}:`, error);
    }
  }

	async addToken(contractAddress: string, networkId: string): Promise<void> {
    try {
      const response = await $client.post('/api/tokens/admin', {contractAddress, networkId}, {
        headers: { authorization: getAccessToken() },
      });

      if (response.status === 200) {
        console.log(`Token ${contractAddress} added successfully`);
      }
    } catch (error) {
      console.error(`Error adding token ${contractAddress}:`, error);
			throw error
    }
  }
}

export const tokensService = new TokensService();
